import { Component, Input, OnInit } from "@angular/core"
import { ColorCodeService } from "../../../services/color-code.service"
import { UserService } from "../../../services/user.service"
import { CardComponent } from "../card.component"

@Component({
    selector: "app-collection-card",
    templateUrl: "./collection-card.component.html",
    styleUrls: ["./collection-card.component.less"],
})
export class CollectionCardComponent extends CardComponent implements OnInit {
    @Input() public gtmDataCardNumber: number

    constructor(
        protected colorCodeService: ColorCodeService,
        public userService: UserService
    ) {
        super(colorCodeService, userService)
    }

    public ngOnInit() {
        this.showAsCollection = true
    }
}
